import React, { useState } from "react";
import { PropertyVisit } from "../services/guestApi";
import { badgeRequest } from "../services/badgeApi";
export default function AdminVisitValidity({
  farmId,
  visits,
  onChange,
}: {
  farmId: string;
  visits: PropertyVisit[];
  onChange: () => void;
}) {
  const [selected, setSelected] = useState<PropertyVisit | null>(null),
    [reason, setReason] = useState(""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const save = async () => {
    if (!selected) return;
    setBusy(true);
    setError("");
    try {
      await badgeRequest(
        farmId,
        "/visits/" + selected.visit_id + "/validity",
        "PUT",
        { valid: !!selected.invalidated_at, reason },
      );
      setSelected(null);
      setReason("");
      onChange();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };
  if (!visits.length) return null;
  return (
    <details className="border rounded-xl p-4">
      <summary className="font-semibold text-sm cursor-pointer">
        Visit eligibility for badges
      </summary>
      <p className="text-xs text-gray-500 mt-3">
        Exclude an invalid stay from milestones or restore a verified stay.
        History and reasons are retained.
      </p>
      <ul className="space-y-2 mt-3">
        {visits.map((v) => (
          <li key={v.visit_id} className="text-sm flex justify-between gap-3">
            <span>
              {new Date(v.arrived_at).toLocaleDateString()} ·{" "}
              {v.invalidated_at ? "Excluded" : "Eligible"}
            </span>
            <button
              className="underline text-usda-700"
              onClick={() => {
                setSelected(v);
                setReason("");
                setError("");
              }}
            >
              {v.invalidated_at ? "Restore" : "Exclude"}
            </button>
          </li>
        ))}
      </ul>
      {selected && (
        <div className="space-y-3 mt-4">
          <label className="block text-sm">
            Reason
            <textarea
              value={reason}
              maxLength={500}
              onChange={(e) => setReason(e.target.value)}
              className="block border rounded-lg p-2 w-full mt-2"
            />
          </label>
          <button
            disabled={busy || !reason.trim()}
            onClick={() => void save()}
            className="bg-usda-700 rounded-lg px-3 py-2 text-white disabled:opacity-50"
          >
            Save correction
          </button>
          <button className="underline ml-3" onClick={() => setSelected(null)}>
            Cancel
          </button>
        </div>
      )}
      {error && (
        <p role="alert" className="text-red-700 text-sm mt-3">
          {error}
        </p>
      )}
    </details>
  );
}
